import { tgxApi } from "../../../app/tgxApi";
import {
    getAuthorizationHeader,
    getFileDownloadHeaders,
    handleQueryError,
    handleQueryErrorAndSuccess
} from "../../../helpers/utils/RtkQueryUtils";
import { getFileName, serialize } from "../../../helpers/utils/Utils";
import { downloadFile } from "../../../helpers/utils/FileUtils";

export const paymentApi = tgxApi.injectEndpoints({
    endpoints: (build) => ({
        searchFnfTransactionApi: build.query({
            query: (data) => {
                // Serialize the data to query parameters
                let paramData = serialize(data);
                return {
                    url: `/ajax/fnf-transactions?${paramData}`,
                    method: 'GET',
                    headers: getAuthorizationHeader()
                };
            },
            providesTags: ['fnfTransaction'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryError(queryFulfilled)
            },
        }),
    
        exportFnfTransactionsData: build.query({
            query: (query) => {
                return {
                    url: `/export/fnf-transactions`,
                    method: 'POST',
                    params: query,
                    headers: getFileDownloadHeaders(),
                    responseType: 'arraybuffer',
                    responseHandler: async (response: { blob: () => any; }) => {
                        const blob = await response.blob();
                        downloadFile(blob, getFileName("fnf_tranactions"))
                        return { success: true };
                    },
                };
            },
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryError(queryFulfilled)
            },
        }),
        getPrimaryCollectorByStateAndCounty: build.query({
            query: ({ stateAbbr, countyName }) => {
                let paramData = serialize({ stateAbbr: stateAbbr, countyName: countyName })
                return {
                    url: `/ajax/primary-collector-by-state-county?${paramData}`,
                    method: 'GET',
                    headers: getAuthorizationHeader(),
                };
            },
            providesTags: ['getPrimaryCollectorByStateAndCounty'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryError(queryFulfilled)
            },
        }),
        updateTransactionStatus: build.mutation({
            query: ({ fnfTransactionId, transactionStatus }) => {
                return {
                    url: `/ajax/updateFnfTransactionStatus/${fnfTransactionId}/${transactionStatus}`,
                    method: 'put',
                    headers: getAuthorizationHeader(),
                };
            },
            invalidatesTags:["fnfTransaction"],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Updated", "FNF Transaction status")
            },
        }),
    }),
});


export const {
    useSearchFnfTransactionApiQuery,
    useUpdateTransactionStatusMutation,
    useLazyExportFnfTransactionsDataQuery
} = paymentApi;